export const LOGOUT = 'LOGOUT';
export const SET_PERFIL = 'SET_PERFIL';
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const CLEAR_ALL = 'CLEAR_ALL';
